import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedAdmin({ children }) {
  const { authed, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="pt-40 text-center font-display text-3xl" data-testid="admin-checking">
        Verifying session…
      </div>
    );
  }
  if (!authed) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
